/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ConnectionBadIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAz0lEQVR4nO2TsQ4BQRCGVy08gJpWcoXZu51xDd6KB6HgATwEISqR6M4MncoJhehPjjtxiYotSO5Lptk/2S+Tf1epnJycnB+CARei8SpAgQAO2KW2VYEAzUVT9DoMON1pv2ZNsq53iuL5DmvsMtDhIaEzg2kq2wTGlFjj+L4N0GnrulXrkkipQiphoMlXlzHgSjQeBXAUGFNJzwWgzIBhLNk0qPWxIFOuxn1GorGXZH0rguQFDZ+Z5ztJF4FNQZhmceGJ4GLzHyzf5LOPBX/LDbKKhvOYVEJtAAAAAElFTkSuQmCC)
 */
export const ConnectionBadIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.STATUS_DANGER,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M2 13a1 1 0 0 1 1-1 9 9 0 0 1 9 9 1 1 0 1 1-2 0 7 7 0 0 0-7-7 1 1 0 0 1-1-1ZM2 17.83c0-.46.37-.83.83-.83C5.13 17 7 18.87 7 21.17c0 .46-.37.83-.83.83H3a1 1 0 0 1-1-1v-3.17Z"
        className={colorClass}
      />
    </svg>
  );
};
